import { sum } from "../../../../services/array-helpers";
import { formatCurrency, formatDate } from "../../../../services/format";
import { FormItemType } from "../../../UI/view/component-map";
import { FormView } from "../../../UI/view/form-view";
import { ListView, ListViewColumnType, initListView, createListView } from "../../../UI/view/list-view";
import { initView, connectView } from "../../../UI/view/view";
import { billingPermissions } from "../billing-datasource";
import { liquidrentalordersDS } from "./liquidrental-unbilled-list";

export const liquidRentalsCreate = {
  editMode: true,
  pageHeader: 'Liquid Rentals Billing',
  permissions: billingPermissions,
  breadcrumbs: [
    {
      name: 'Liquid Rentals Billing',
      icon: 'currency-dollar',
      to: '/billing/liquid',
    },
  ],
  items: [
    {
      type: FormItemType.masterDetailLayout,
      items: [
        {
          type: FormItemType.infoPane,
          header: ({ liquidrentalbill }) => liquidrentalbill?.current?.data?.customerName,
          infoListItems: [

            {
              label: 'Customer',
              name: 'customerName'
            },
            {
              label: 'Customer Id',
              name: 'liquidCustomerId'
            },
            {
              label: 'Free Days Per Trip',
              name: 'freeDays'
            },  
            {
              label: 'Price Charged Per Month',
              name: 'pricePerMonth',
              value: ({ pricePerMonth }) => formatCurrency(pricePerMonth)
            },
            {
              label: 'Price Charged Per Day',
              name: 'pricePerDay',
              value: ({ pricePerDay }) => formatCurrency(pricePerDay)
            },
            {
              label: 'Price Per Month HP',
              name: 'pricePerMonthHP',
              value: ({ pricePerMonthHP }) => formatCurrency(pricePerMonthHP)
            },
            {
              label: 'Price Per Day HP',
              name: 'pricePerDayHP',
              value: ({ pricePerDayHP }) => formatCurrency(pricePerDayHP)
            },
            {
              label: 'Chassis Price Per Month',
              name: 'chassisPricePerMonth',
              value: ({ chassisPricePerMonth }) => formatCurrency(chassisPricePerMonth)
            },
            {
              label: 'Chassis Price Per Day',
              name: 'chassisPricePerDay',
              value: ({ chassisPricePerDay }) => formatCurrency(chassisPricePerDay)
            },
            {
              label: 'Billing Period',
              name: 'billingPeriod',
              value: ({ invoiceMonth, invoiceYear }) => `${invoiceMonth}/${invoiceYear}`
            },
            {
              label: 'Total',
              value: (a, watch) => {
                const vals = watch('liquidRentalBillingDetails');
                if (!vals) return '';
                return formatCurrency(sum(vals.map((v) => v.value)));
              }
            },
          ]
        },
        {
          type: FormItemType.tab,
          items: [
            {
              label: 'Liquid Rentals',
              items: [
                {
                  type: FormItemType.fieldset,
                  label: 'Rental Billing',
                  items: [
                    {
                      name: 'invoiceErrors',
                      type: FormItemType.labelField,
                      style: {color: 'red'},
                    },
                    {
                      name: 'pricingErrors',
                      type: FormItemType.labelField,
                      style: {color: 'red'},
                    },
                    {
                      name: 'billingComments',
                      type: FormItemType.labelField,
                      style: {color: 'red'},
                    },
                    {
                      name: 'hasHPPOrder',
                      type: FormItemType.labelField,
                    },
                    {
                      name: 'missingHpPricing',
                      type: FormItemType.labelField,
                      style: {color: 'red'},
                    },
                    {
                      type: FormItemType.row,
                      items: [
                        {
                          name: 'ponumber',
                          label: 'PO Number',
                          minWidth: 200,
                          fitToContent: true,
                          defaultValue: ''
                        },
                      ]
                    },
                    {
                      name: 'invoiceNotes',
                      label: 'Invoice Notes',
                      type: FormItemType.textarea,
                      defaultValue: ''
                    },
                    {
                      name: 'liquidRentalBillingDetails',
                      type: FormItemType.editTable,
                      hideAddButton: true,
                      variant: 'tabular',

                      toolbar: [
                        {
                          type: FormItemType.checkboxField,
                          inline: true,
                          label: 'Edit PO Number',
                          name: 'Postyle',
                          width: 130,
                          fitToContent: true,
                        },
                      ],
                      columns: [
                        {
                          type: ListViewColumnType.delete,
                          accessor: 'delete',
                        },
                        {
                          accessor: 'ponumber',
                          Header: 'PO Number',
                          formItemProps: {
                            disabled: ({ watch }) => !watch('Postyle'),
                            name: 'ponumber',
                            defaultValue: '',
                            maxLength: 50,
                          }
                        },
                        {
                          Header: 'Container ID',
                          accessor: 'containerId',
                          defaultSort: true,
                          formItemProps: {
                            name: 'containerId',
                            disabled: () => true,
                          }
                        },
                        {
                          Header: 'Booking ID',
                          accessor: 'bookingId',
                          formItemProps: {
                            name: 'bookingId',
                            disabled: () => true,
                          }
                        },
                        {
                          Header: 'Port Name',
                          accessor: 'terminalName',
                          formItemProps: {
                            name: 'terminalName',
                            disabled: () => true,
                          }
                        },
                        {
                          Header: 'Port Arrival Date',
                          type: ListViewColumnType.date,
                          accessor: 'startDate',
                          formItemProps: {
                            name: 'startDate',
                            type: FormItemType.date,
                            disabled: () => true,
                          }
                        },
                        {
                          Header: 'Port Release Date',
                          type: ListViewColumnType.date,
                          accessor: 'endDate',
                          formItemProps: {
                            name: 'endDate',
                            type: FormItemType.date,
                            disabled: () => true,
                          }
                        },
                        {
                          Header: 'Days Billable',
                          accessor: 'daysBilled',
                          formItemProps: {
                            name: 'daysBilled',
                            disabled: () => true,
                          }
                        },
                        {
                          Header: 'Total $',
                          accessor: 'value',
                          formItemProps: {
                            name: 'value',
                            disabled: () => true,
                          }
                        },

                      ]
                    },
                    {
                      name: 'billingType',
                      defaultValue: 'LIQUIDRENTAL',
                      hideIf: () => true
                    },
                    {
                      name: 'productType',
                      defaultValue: 'Liquid',
                      hideIf: () => true
                    },
                    {
                      name: 'customerId',
                      hideIf: () => true
                    },
                    {
                      name: 'liquidCustomerId',
                      computedValue: (getValues) => getValues('customerId'),
                      hideIf: () => true
                    },
                    {
                      name: 'roNumber',
                      defaultValue: '',
                      hideIf: () => true
                    },
                    {
                      name: 'bypassInvoice',
                      defaultValue: false,
                      hideIf: () => true
                    },
                  ]
                }
              ],
              footerItems: [
                {
                  type: FormItemType.button,
                  label: 'Bypass Invoice',
                  variant: 'secondary',
                  handler: async ({ methods, handleSubmit, onSubmit, redirect, confirm }) => {
                    const { setValue } = methods;
                    setValue('bypassInvoice', true);
                    let isError = false;
                    let result = null;
                    try {
                      result = await handleSubmit(onSubmit)();
                    } catch {
                      isError = true;
                    }
                    if (isError) {
                      await confirm('There was an error bypassing this invoice.', true);
                    } else {
                      //redirect to created invoice. We need the invoice id!\
                      await confirm('Invoice Bypassed.', true);
                      redirect('/billing/liquid');
                    }
                  }
                },
                {
                  type: FormItemType.submitButton,
                  label: 'Create Invoice',
                  variant: 'secondary',
                  onAfterSubmit: ({ redirect }) => {
                    alert('Invoice Successfully Created!')
                    redirect('/billing/liquid');
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
} as FormView;

export const [LiquidRentalInvoice, LiquidRentalInvoiceRepo] = connectView({ form: liquidRentalsCreate, dataSource: liquidrentalordersDS });
